export const API_ENDPOINTS={
    register:'/register-user',
    fetchClubs:'/fetch-clubs',
    userSuggestedSong:'/user-suggested-song',
    clubSongs:'/club-songs',
    removeSuggestedSong:'/remove-suggested-song',
    addSongToList:'/add-song-to-list',
    removeSongFromList:'/remove-song-from-list',
    likeUnlikeSong:'/like-unlike-song',
    fetchLikedSongs:'/fetch-liked-songs',
    updateClub:'/update-club',
    deleteClub:'/delete-club',
    addModerator:'/add-moderator',
    getModerators:'/get-moderators',
    addClub:'/add-club',
    deleteMod:'/delete-mod',
    likeSong:'/like-song',
    unlikeSong:'/unlike-song',
    //youtubeBaseUrl:'https://www.googleapis.com/youtube/v3',
    //youtubeSearch:'/search',
    spotifySearchUrl: 'https://api.spotify.com/v1/search',
    getIp:'https://geolocation-db.com/json/',
    spotifyLoginUrl:'https://accounts.spotify.com/api/token',
}